<template>
    <client-page>
        <sub-visual v-bind="visual" />

        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <business-intro v-bind="intro" />
                </v-container>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">주요 프로그램</h2>
                    </div>

                    <program-list :items="programs" />
                </v-container>
            </section>
        </div>
        <section>
            <bottom-banner :item="banner" />
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BusinessIntro from "@/components/client/business/business-intro.vue";
import ProgramList from "@/components/client/business/program-list.vue";
import BottomBanner from "@/components/client/business/bottom-banner.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        BusinessIntro,
        ProgramList,
        BottomBanner,
    },
    data() {
        return {
            visual: {
                sh: "해외사업",
                tabActive: "인도적 지원사업",
                text: "우리는 글로벌 연대, 지속 가능한 개발과 <br />나눔을 만들어 갑니다.",
                bg: "/images/business/overseas/visual.jpg",
                mobile: "/images/business/overseas/mobile-visual.jpg"
            },
            intro: {
                image: "/images/business/overseas/aid/intro.jpg",
                title: "인도적 지원사업",
                texts: "재난과 분쟁으로 어려움을 겪는 지구촌 아이들이 안정된 삶의 터전을 되찾고 일상으로 복귀하도록 돕습니다. <br class='d-none d-xl-block' />구호 물자 지원부터 재건까지, 지속 가능한 인도적 지원을 실천해 왔습니다.",
            },
            programs: [
                {
                    image: "/images/business/overseas/aid/program-1.jpg",
                    title: "자연재난 지원",
                    texts: [
                        "지진, 홍수, 가뭄과 같은 자연 재해로 고통받는 지구촌 이웃들이 <br class='d-none d-xl-block' />빠르게 안전을 확보하고 정상적인 삶으로 복귀할 수 있도록 지원합니다.",
                        //
                    ],
                },
                {
                    image: "/images/business/overseas/aid/program-2.jpg",
                    title: "난민 지원",
                    texts: [
                        "전 세계의 난민들이 전쟁과 박해를 피해 새로운 삶을 시작할 수 있도록, <br class='d-none d-xl-block' />안전한 환경과 생계 지원을 통해 그들의 자립을 돕습니다.",
                        //
                    ],
                },
            ],
            banner: {
                image: "/images/business/overseas/aid/bottom-banner.jpg",
                mobile: "/images/business/overseas/aid/bottom.jpg",
                white: true,
            },
        };
    },
};
</script>